import { getBlob, post } from '../client';

export const bulkImportApi = {
  downloadEquipmentTypesTemplate: () =>
    getBlob('/bulk-import/equipment-types/template'),
  validateEquipmentTypes: (fileBase64) =>
    post('/bulk-import/equipment-types/validate', { fileBase64 }),
  commitEquipmentTypes: (rows) =>
    post('/bulk-import/equipment-types/commit', { rows }),

  downloadBuSitesTemplate: () =>
    getBlob('/bulk-import/business-units-sites/template'),
  validateBuSites: (fileBase64) =>
    post('/bulk-import/business-units-sites/validate', { fileBase64 }),
  commitBuSites: (payload) =>
    post('/bulk-import/business-units-sites/commit', payload),

  downloadUsersTemplate: () => getBlob('/bulk-import/users/template'),
  validateUsers: (fileBase64) =>
    post('/bulk-import/users/validate', { fileBase64 }),
  commitUsers: (payload) => post('/bulk-import/users/commit', payload),

  downloadUserEquipmentTemplate: () =>
    getBlob('/bulk-import/user-equipment/template'),
  validateUserEquipment: (fileBase64) =>
    post('/bulk-import/user-equipment/validate', { fileBase64 }),
  commitUserEquipment: (payload) =>
    post('/bulk-import/user-equipment/commit', payload),
};
